import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { Type } from "class-transformer";
import { EnaioCall } from "./EnaioCall";
import { EnaioCondition } from "./EnaioCondition";
import { EnaioObjectTypeId } from "./EnaioObjectTypeId";
import { EnaioObjectTypeStatistics } from "./EnaioObjectTypeStatistics";

export class EnaioCallGetObjectTypeStatistics extends EnaioCall <EnaioObjectTypeStatistics[]> {
    @Type(() => EnaioObjectTypeId)
    objectTypes: EnaioObjectTypeId[];
    byMimeType = true;
    followForeignIds = true;
    countDuplicateForeignIds = true;
    countMultipleDocumentsOfIdAsOne = false;
    @Type(() => EnaioCondition)
    conditions: EnaioCondition[];
    getModelType(): AdvancedType {
        return AdvancedType.ofClass(EnaioObjectTypeStatistics, 1);
    }

}
